const TRANSITION = {
  TRANSITION_EASE_IN_OUT: 'all 0.3s ease'
}

export default TRANSITION
